/* Copyright (c) 2017 Backpack Health LLC */

const MedliNames = {
  category: {
    condition: 'condition',
    procedure: 'procedure',
    medication: 'treatment',
    otherTreatment: 'other_treatment',
    vaccination: 'vaccination',
    medicationAllergy: 'medication_allergy',
    foodAllergy: 'food_allergy',
    allergy: 'other_allergy',
    medicationName: 'medication_name',
    food: 'food',
    lab: 'lab',
    measurement: 'measurement',
    anatomy: 'anatomy',
    reaction: 'reaction',
    unit: 'unit',
    stoppingReason: 'treatment_stop',
    descriptor: 'descriptor',
    gene: 'gene',
  },

  list: {
    condition: 'condition',
    procedure: 'procedure',
    medication: 'treatment',
    otherTreatment: 'other_treatment',
    vaccination: 'vaccination',
    medicationAllergy: 'medication_allergy',
    foodAllergy: 'food_allergy',
    allergy: 'other_allergy',
    medicationName: 'medication_name',
    measurement: 'measurement',
    lab: 'lab',
    anatomy: 'anatomy',
    reaction: 'reaction',
    unitMedication: 'unit',
    stoppingReason: 'treatment_stop',
    descriptor: 'descriptors',
    unitLab: 'unit_lab',
    unitMeasurement: 'unit_measurement',
    gene: 'gene',
    geneVariantClassification: 'gene_variant_classification',
    geneMutationType: 'gene_mutation_type',
    geneExonFrameType: 'gene_exon_frame_type',
    geneZygosityType: 'gene_zygosity_type',
  },

  constant: {
    allergy: 'other_allergy',
    stoppingReason: 'stopping_reason',
    unitMedication: 'unit',
    unitMeasurement: 'unit_measurement',
    unitLab: 'unit_lab',
    descriptor: 'descriptor',
    unitNA: 'unit_na',
  },

  composite: {
    unit: 'unit',
  },
};

export enum eMedliEquivalentCategoryName {
  condition = 'condition',
  procedure = 'procedure',
  medication = 'treatment',
  other_treatment = 'other_treatment',
  vaccination = 'vaccination',
  medication_allergy = 'medication_allergy',
  food_allergy = 'food_allergy',
  allergy = 'other_allergy',
  medication_name = 'medication_name',
  food = 'food',
  lab = 'lab',
  measurement = 'measurement',
  anatomy = 'anatomy',
  reaction = 'reaction',
  unit = 'unit',
  stopping_reason = 'treatment_stop',
  descriptor = 'descriptor',
  gene = 'gene',
}

export enum eMedliCategoryName {
  condition = 'condition',
  procedure = 'procedure',
  medication = 'treatment',
  otherTreatment = 'other_treatment',
  vaccination = 'vaccination',
  medicationAllergy = 'medication_allergy',
  foodAllergy = 'food_allergy',
  allergy = 'other_allergy',
  medicationName = 'medication_name',
  food = 'food',
  lab = 'lab',
  measurement = 'measurement',
  anatomy = 'anatomy',
  reaction = 'reaction',
  unit = 'unit',
  stoppingReason = 'treatment_stop',
  descriptor = 'descriptor',
  gene = 'gene',
}
export enum eMedliListName {
  condition = 'condition',
  procedure = 'procedure',
  medication = 'treatment',
  otherTreatment = 'other_treatment',
  vaccination = 'vaccination',
  medicationAllergy = 'medication_allergy',
  foodAllergy = 'food_allergy',
  allergy = 'other_allergy',
  medicationName = 'medication_name',
  measurement = 'measurement',
  lab = 'lab',
  anatomy = 'anatomy',
  reaction = 'reaction',
  unitMedication = 'unit',
  stoppingReason = 'treatment_stop',
  descriptor = 'descriptors',
  unitLab = 'unit_lab',
  unitMeasurement = 'unit_measurement',
  gene = 'gene',
  geneVariantClassification = 'gene_variant_classification',
  geneMutationType = 'gene_mutation_type',
  geneExonFrameType = 'gene_exon_frame_type',
  geneZygosityType = 'gene_zygosity_type',
}
export enum eMedliConstantName {
  allergy = 'other_allergy',
  stoppingReason = 'stopping_reason',
  unitMedication = 'unit',
  unitMeasurement = 'unit_measurement',
  unitLab = 'unit_lab',
  descriptor = 'descriptor',
  unitNA = 'unit_na',
}

export enum eMedliCompositeName {
  unit = 'unit',
}
export enum eMedliCategorySubtype {
  medication = 'medication',
  food = 'food',
  other = 'other',
}

export default MedliNames;
